/*
  selling-plan-mirror.js — added 2026-08-19.

  The subscription app renders its purchase-options widget in a theme app block that
  sits OUTSIDE the product form, and its hidden selling_plan field carries no form
  attribute. The form therefore never submits it, so a shopper who chose a
  subscription had a one-time item added at full price instead.

  This copies the app's selling_plan value into a mirror field inside the form.
  An empty value means one-time purchase, which is correct.

  Both sides are re-queried on every sync rather than held as references, because
  the theme re-renders the product form and the app re-renders its widget, either of
  which replaces the fields we would otherwise be watching.
*/
(function () {
  'use strict';

  function sync() {
    var mirrors = document.querySelectorAll('input[data-selling-plan-mirror]');
    if (!mirrors.length) return;

    Array.prototype.forEach.call(mirrors, function (mirror) {
      var form = mirror.closest('form[action*="/cart/add"]');
      if (!form) return;

      var source = Array.prototype.find.call(
        document.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]'),
        function (el) { return el !== mirror && !form.contains(el); }
      );
      if (!source) return;

      var value = source.value || '';
      if (mirror.value !== value) mirror.value = value;
    });
  }

  // Ahead of anything that reads the form, and often enough to survive re-renders.
  document.addEventListener('click', sync, true);
  document.addEventListener('change', sync, true);
  document.addEventListener('submit', sync, true);
  setInterval(sync, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  }
  sync();
})();
